<ng-template #railItem let-section>
  <a
    matRipple
    class="rail__item"
    [class.rail__item--active]="isActive(section)"
    [class.rail__item--hover]="flyout()?.section === section"
    [routerLink]="section.url"
    [attr.aria-label]="section.name"
    (mouseenter)="openFlyout(section, $event.currentTarget)"
    (mouseleave)="closeFlyout()"
    (focus)="openFlyout(section, $event.currentTarget)"
    (blur)="closeFlyout()"
    (click)="closeFlyout(true)"
  >
    <span class="rail__icon"
      ><mat-icon>{{ section.icon }}</mat-icon></span
    >
    <span class="rail__label">{{ section.shortName }}</span>
  </a>
</ng-template>

<aside class="rail" (keydown.escape)="closeFlyout(true)">
  <nav class="rail__links">
    <ng-container *ngTemplateOutlet="railItem; context: { $implicit: home }" />
    @for (section of links(); track section.url) {
      <ng-container *ngTemplateOutlet="railItem; context: { $implicit: section }" />
    }
  </nav>

  @if (showConfig) {
    <div class="rail__footer">
      <ng-container *ngTemplateOutlet="railItem; context: { $implicit: settings }" />
    </div>
  }
</aside>

@if (hint(); as tip) {
  <div class="hint" [style.top.px]="tip.center">{{ tip.text }}</div>
}

@if (flyout(); as panel) {
  <div
    class="flyout"
    role="menu"
    [class.flyout--wide]="twoColumns(panel.section)"
    [style.top.px]="panel.top"
    (mouseenter)="keepFlyout()"
    (mouseleave)="closeFlyout()"
    (focusin)="keepFlyout()"
    (focusout)="closeFlyout()"
  >
    <a class="flyout__head" [routerLink]="panel.section.url" (click)="closeFlyout(true)">
      <span class="flyout__head-icon"
        ><mat-icon>{{ panel.section.icon }}</mat-icon></span
      >
      <span class="flyout__head-text">
        <strong>{{ panel.section.name }}</strong>
        <span>{{ panel.section.sublinks.length }} páginas</span>
      </span>
      <mat-icon class="flyout__head-go">arrow_forward</mat-icon>
    </a>

    <div class="flyout__links">
      @for (link of panel.section.sublinks; track link.url) {
        <a
          class="flyout__link"
          role="menuitem"
          [class.flyout__link--active]="isCurrentPage(link.url)"
          [routerLink]="link.url"
          (click)="closeFlyout(true)"
        >
          <mat-icon>{{ link.icon ?? 'chevron_right' }}</mat-icon>
          <span>{{ link.name }}</span>
        </a>
      }
    </div>
  </div>
}

<div class="drawer-backdrop" [class.drawer-backdrop--open]="expandMenu" (click)="toggleMenu(false)"></div>

<aside class="drawer" [class.drawer--open]="expandMenu">
  <img class="drawer__logo" src="../assets/images/linkerweb-light-logo.png" alt="Linkerweb" />

  <nav class="drawer__links">
    @for (section of [home].concat(drawerLinks()); track section.url) {
      <a
        class="drawer__item"
        [class.drawer__item--active]="isActive(section)"
        [routerLink]="section.url"
        (click)="toggleMenu(false)"
      >
        <mat-icon>{{ section.icon }}</mat-icon>
        {{ section.name }}
      </a>
      @for (link of section.sublinks; track link.url) {
        <a
          class="drawer__sublink"
          [class.drawer__sublink--active]="isCurrentPage(link.url)"
          [routerLink]="link.url"
          (click)="toggleMenu(false)"
        >
          {{ link.name }}
        </a>
      }
    }
  </nav>

  @if (showConfig) {
    <a
      class="drawer__item"
      [class.drawer__item--active]="isActive(settings)"
      routerLink="/admin"
      (click)="toggleMenu(false)"
    >
      <mat-icon>settings</mat-icon>
      Configuración
    </a>
  }
</aside>
